export default {
  home: 'Home',
  company: {
    title: 'About Us',
    introduction: 'Company Profile',
    structure: 'Subsidiary Organizations',
    dream: 'Vision & mission',
    events: 'Memorabilia',
    partners: 'Partners',
    honors: 'Honors & Qualifications'
  },
  applications: {
    title: 'Applications',
    magnetic: 'Superconducting Magnet',
    nuclear: 'Compact Fusion',
    power: 'Superconducting Electric Power'
  },
  products: {
    title: 'Products & Services',
    tape: '2G HTS Tapes',
    performance: 'Performance',
    advantages: 'Core Strengths',
    service: 'Technical Service'
  },
  news: {
    title: 'Company News',
    company: 'Company News',
    downloads: 'Related Publications'
  },
  recruit: 'Career',
  contact: {
    title: 'Contact Us',
    recruit: 'Career',
    postdoc: 'Postdoctoral Station',
    info: 'Contact Information'
  }
};